import { DateFieldUI } from '@axo/form/feature/form-input/DateField/DateFieldUI';
import { DropdownFieldUI } from '@axo/form/feature/form-input/DropdownField/DropdownFieldUI';
import { RadioFieldUI } from '@axo/form/feature/form-input/RadioField/RadioFieldUI';
import { useTranslation } from '@axo/shared/i18n';
import { Grid } from '@axo/ui-core/components/layout/item';
import { useFormContext } from 'react-hook-form';
import {
  citizenshipOptions,
  educationOptions,
  radioOptions,
} from '../../../config/globals';
import { gridColumns } from '../../../config/layouts/grid';
import { CitizenFormGroupData } from '../../../FormData.no.types';
import styles from '../../../loan.module.scss';
import {
  citizenShipFieldOptions,
  livedInMarketCountrySinceFieldOptions,
} from './config';

export function CitizenFormGroup() {
  const { t } = useTranslation();

  const { watch } = useFormContext();

  const isNorwegian = watch('Frontend/IsNorwegian') === 'Yes';

  const currentYear = new Date().getFullYear();

  return (
    <>
      <Grid columns={gridColumns}>
        <RadioFieldUI<CitizenFormGroupData>
          name="LoanApplication/Education"
          label={t('Education.label')}
          data-testid="education-radio"
          radioStyle="both"
          options={educationOptions}
        />

        <RadioFieldUI<CitizenFormGroupData>
          name="Frontend/IsNorwegian"
          label={t('IsNorwegian.label')}
          data-testid="is-norwegian-radio"
          options={radioOptions}
          radioStyle="both"
        />
      </Grid>

      {!isNorwegian && (
        <div className={styles.inputGroup} data-grey={true}>
          <Grid columns={gridColumns}>
            <DropdownFieldUI<CitizenFormGroupData>
              name="LoanApplication/Citizenship"
              label={t('Citizenship.label')}
              data-testid="citizenship-dropdown"
              options={citizenshipOptions}
              {...citizenShipFieldOptions}
            />

            <DateFieldUI<CitizenFormGroupData>
              name="LoanApplication/LivedInMarketCountrySince"
              label={t('LivedInMarketCountrySince.label')}
              data-testid="lived-in-market-country-since-dropdown"
              yearPlaceholder={t('LivedInMarketCountrySince.placeholder')}
              minYearSuffix={t('LivedInMarketCountrySince.year.suffix')}
              minYear={currentYear - 10}
              maxYear={currentYear}
              i18n="no-NO"
              showYearOnly
              latestYearAtTop
              rules={livedInMarketCountrySinceFieldOptions.registerOptions}
            />
          </Grid>
        </div>
      )}
    </>
  );
}
